import React, { useState } from "react";

export default function DeleteAccount() {
    const [username, setUsername] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!username.trim()) {
            setError("Please enter your username");
            return;
        }

        setError("");

        try {
            setSubmitted(true);
        } catch (err) {
            setError("Something went wrong. Please try again.");
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2>Delete Account Request</h2>

                {!submitted ? (
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            placeholder="Enter your username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={styles.input}
                        />

                        {error && <p style={styles.error}>{error}</p>}

                        <button type="submit" style={styles.button}>
                            Request Account Deletion
                        </button>
                    </form>
                ) : (
                    <div style={styles.successBox}>
                        <p>✅ Your request has been submitted successfully.</p>
                        <p>
                            Your account will be permanently deleted within <b>24 hours</b>.
                        </p>
                    </div>
                )}

                <p style={styles.note}>
                    ⚠️ Once deleted, your account and all associated data cannot be
                    recovered.
                </p>
            </div>
        </div>
    );
}

const styles = {
    container: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa",
    },
    card: {
        width: "350px",
        padding: "25px",
        borderRadius: "10px",
        background: "#fff",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        textAlign: "center",
    },
    input: {
        width: "100%",
        padding: "10px",
        marginTop: "15px",
        borderRadius: "5px",
        border: "1px solid #ccc",
    },
    button: {
        width: "100%",
        padding: "10px",
        marginTop: "15px",
        background: "#e74c3c",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    error: {
        color: "red",
        marginTop: "10px",
    },
    successBox: {
        marginTop: "20px",
        color: "green",
    },
    note: {
        marginTop: "15px",
        fontSize: "12px",
        color: "#888",
    },
};